import { Injectable } from "@angular/core";
import{ Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable()
export class PropiedadService {
    public url;

    constructor(private _http: Http){
        this.url = GLOBAL.url;
    }
      
    getPropiedad(rol?,id?, dir?, num?) {
        var params;
        
        if(rol && dir == undefined && num == undefined){
            params = {
                rol: rol,
                id: id
            }
        }
        if(dir && num && rol == undefined){
            params = {
                dir: dir,
                num: num
            }
        }
        console.log("getPropiedad() propiedad.service.ts",params)
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url+'get/propiedad', params, {headers: headers})
        .pipe(map(res => res.json()));
    }

    savePropiedad(rol) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url+'save/propiedad', rol, {headers: headers})
        .pipe(map(res=> res.json()));
    }


    traerCalles(){
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            param: "param"
        }
        return this._http.post(this.url+'traerCalles',params, {headers:headers})
        .pipe(map(res => res.json()));
    }

    getCalles(){
        let headers = new Headers({
            'Content-type': 'application/json'
        });

        return this._http.get(this.url+'get/calles', {headers: headers})
        .pipe(map(res=> res.json()));
    }
}